import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '../typography';
import colors from '../../../assets/styles/colors';
import commons from '../../../assets/styles/commons';
import { Box, FormHelperText } from '@material-ui/core';
import { Control, Controller } from 'react-hook-form';

interface RadioOption {
  value: string;
  label: string;
}

interface Props {
  selectedValue: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  title?: string;
  control?: Control<any>;
  name?: string;
}

const RadioGroupCustom: React.FC<Props> = ({
  selectedValue,
  onChange,
  options,
  title,
  control,
  name,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange((event.target as HTMLInputElement).value);
  };

  return (
    <Box component="div">
      <Controller
        name={name || ''}
        control={control}
        render={({
          field: { value, onChange, ref, onBlur },
          fieldState: { error },
        }) => (
          <FormControl>
            <Typography fontWeight="700" color="secondary">
              {title}
            </Typography>
            <>
              <RadioGroup
                row
                value={selectedValue}
                onChange={handleChange}
                sx={{
                  '.MuiTypography-root': { fontFamily: commons.fontFamily },
                }}
              >
                {options.map(option => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    ref={ref}
                    onBlur={onBlur}
                    control={
                      <Radio
                        sx={{
                          color: colors.primary.orange,
                          '&.Mui-checked': {
                            color: colors.primary.orange,
                          },
                        }}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </RadioGroup>
              {error && (
                <FormHelperText style={{ color: colors.error.intenseRed }}>
                  {error.message}
                </FormHelperText>
              )}
            </>
          </FormControl>
        )}
      />
    </Box>
  );
};

export default RadioGroupCustom;
